import React from 'react';
import './DeclineConfirmModal.css'; // Reuse the same styling

const DeclineReplacementModal = ({ onClose, onConfirm, channels, channelToDecline }) => {
  // Filter to get only approved channels, excluding the one being declined
  const approvedChannels = channels.filter(channel => 
    !channel.declined && channel.id !== channelToDecline
  );

  return (
    <div className="decline-confirm-modal-overlay" onClick={onClose}>
      <div className="decline-confirm-modal-content" onClick={e => e.stopPropagation()}>
        <button className="decline-confirm-modal-close" onClick={onClose}>×</button>
        
        <h2>Before you decline ...</h2>
        
        <p>The channel(s) is currently set in one or more zones.</p>
        <p>Please select a replacement channel.</p>
        
        <div className="decline-replacement-select">
          <select>
            {approvedChannels.map(channel => (
              <option key={channel.id} value={channel.id}>
                {channel.name}
              </option>
            ))}
          </select>
        </div>

        <button className="decline-confirm-modal-button" onClick={onConfirm}>
          Confirm
        </button>
      </div>
    </div>
  );
};

export default DeclineReplacementModal; 